import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isMDM = true;
const transportGet = async (options) => {
  const resourcePath = `${Constants.PATH.MDM.TRANSPORT.transport}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const transportDocDetailsGet = async (transport_ref_id, options) => {
  const resourcePath = `${Constants.PATH.MDM.TRANSPORT.transportDocDetails}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { transport_ref_id },
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { transportGet, transportDocDetailsGet };
